import Telepathy from '@/lib/telepathy'
import {Boot} from '@/project'

declare module 'vue/types/vue' {
  interface Vue {
    $telepathy: (name: string, eventInitDict?: CustomEventInit) => void
  }
}

/**
 * Telepathy
 * please do not use this too much
 * use for messaging between a layout and a page only
 * @param Vue
 * @param options Telepathy options
 * @example send a message
 * this.$telepathy('my-event')
 * @example receive a message
 * <dev v-telepathy @telepathy-my-event="onEvent" />
 * @example receive a message
 * <telepathy @telepathy-my-event="onEvent" />
 */
const boot: Boot = ({Vue}, options) => {
  Vue.use(Telepathy, options)
}

export default boot
